<template>
  <div class="message">
    <h2>{{ headline }}</h2>
    <p>
      {{ message }}
    </p>
  </div>
</template>

<style lang="stylus" scoped>
  .message
    margin-top 20%
    padding 0 10%
    text-align center
</style>

<script>
  export default {
    name: 'Message',
    props: {
      headline: {
        type: String,
        required: true
      },
      message: {
        type: String,
        required: true
      }
    },

    mounted () {
      this.$loading(false)
    }
  }
</script>
